/** Quiosque da loja (ADR 0031): fora do layout do staff e do portal, com o token do aparelho. */
export const QUIOSQUE_PAGE = () => "/quiosque";
